import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import { proximaEtapa, textoProximaEtapa } from '../../data/fluxoAvaliacao';
import '../../css/Anamnese.css';
import '../../css/style.css';
import ImagensSilhuetas from '../../images/anamneseMulhersCorpos.png';

// Dados das perguntas
const PERGUNTAS = [
    { id: 0, texto: "1. Qual é o tipo de Diabetes Mellitus que você tem?", tipo: "radio" },
    { id: 1, texto: "2. Há quanto tempo você sabe que é portador(a) de Diabetes Mellitus?", tipo: "radio" },
    { id: 2, texto: "3. Atualmente, você faz acompanhamento nutricional com nutricionista para controlar o Diabetes Mellitus?", tipo: "radio" },
    { id: 3, texto: "4. Atualmente, você faz uso de fármacos para controlar o Diabetes Mellitus?", tipo: "radio" },
    { id: 4, texto: "5. Se faz uso de fármacos, quais são eles e a dosagem diária utilizada?", tipo: "text", placeholder: "Ex: Insulina - 20 UI, Metformina - 850mg" },
    { id: 5, texto: "6. Considerando o último exame de sangue realizado, qual foi o valor da hemoglobina glicada?", tipo: "text", placeholder: "Ex: 6.5%" },
    { id: 6, texto: "7. Você tem conhecimento ou o médico já diagnosticou alguma das doenças abaixo?", tipo: "checkbox", temOutros: true },
    { id: 7, texto: "8. Você já teve alguma complicação crônica em função do Diabetes Mellitus?", tipo: "checkbox", temOutros: true },
    { id: 8, texto: "9. Você já teve crises de hiperglicemia? (Se sim, por favor, descreva o que sentiu)", tipo: "text", placeholder: "Ex: Não / Sim, senti muita sede, boca seca e dor de cabeça" },
    { id: 9, texto: "10. Você já teve crises de hipoglicemia? (Se sim, por favor, descreva o que sentiu)", tipo: "text", placeholder: "Ex: Não / Sim, senti suor frio, tontura e tremedeira" },
    { id: 10, texto: "11. Quais são seus objetivos com o programa de treinamento?", tipo: "checkbox", temOutros: true },
    { id: 11, texto: "12A. Atualmente, você faz algum tipo de exercício físico?", tipo: "radio" },
    { id: 12, texto: "12B. Se respondeu SIM na anterior, qual exercício, frequência, tempo e intensidade você pratica?", tipo: "text", placeholder: "Ex: Caminhada, 4x na semana, 40 min, intensidade leve" },
    { id: 13, texto: "13. Alguma vez, durante a prática de exercício físico, sentiu alguns dos sintomas listados abaixo?", tipo: "checkbox", temOutros: true },
    { id: 14, texto: "14. Você faz quantas refeições por dia?", tipo: "radio" },
    { id: 15, texto: "15. Nos últimos 30 dias, você teve problemas para controlar a glicemia? Se sim, quantas vezes?", tipo: "radio" },
    { id: 16, texto: "16. Você faz o monitoramento diário da glicemia? Se sim, selecione o método utilizado:", tipo: "checkbox" },
    { id: 17, texto: "17. Quanto tempo faz da sua última visita ao médico para controle do Diabetes Mellitus?", tipo: "radio" },
    { id: 18, texto: "18. Caso queira relatar algo que julgue importante e que pode ajudar na elaboração do treino, escreva abaixo:", tipo: "text", placeholder: "Descreva aqui..." }
];

const OPCOES_RESPOSTAS = [
    { id: 0, opcoes: ["Tipo 1", "Tipo 2"] },
    { id: 1, opcoes: ["menos de 1 ano", "entre 1 e 2 anos", "entre 3 e 4 anos", "entre 5 e 6 anos", "entre 7 e 10 anos", "mais de 10 anos"] },
    { id: 2, opcoes: ["SIM", "NÃO"] },
    { id: 3, opcoes: ["SIM", "NÃO"] },
    { id: 4, opcoes: [] },
    { id: 5, opcoes: [] },
    { id: 6, opcoes: ["Nenhuma", "Hipertensão arterial", "Dislipidemia", "Esteatose hepática não-alcoólica (gordura no fígado)", "Doença artéria coronariana", "Doença Renal", "Insuficiência cardíaca", "Câncer", "Neuropatias"] },
    { id: 7, opcoes: ["Retinopatia", "Neuropatia autonômica cardiovascular", "Nefropatia diabética", "Aterosclerose", "Infarto do miocárdio", "Acidente vascular encefálico", "Doença arterial periférica", "Nenhuma complicação"] },
    { id: 8, opcoes: [] },
    { id: 9, opcoes: [] },
    { id: 10, opcoes: ["Controlar o diabetes mellitus", "Emagrecer", "Ganhar força e massa muscular", "Diminuir dor corporal"] },
    { id: 11, opcoes: ["SIM", "NÃO"] },
    { id: 12, opcoes: [] },
    { id: 13, opcoes: ["Nenhum", "Tontura", "Vômito", "Tosse", "Sensação de fraqueza", "Sensação de desmaio", "Visão escurecer", "Formigamento nos dedos das mãos ou pés", "Espasmo (tremedeira)"] },
    { id: 14, opcoes: ["até 3", "entre 3 e 4", "5 ou mais"] },
    { id: 15, opcoes: ["Não tive problemas", "Tive problema 1 vez", "Tive problema 2 vezes", "Tive problema 3 vezes", "Tive problema 4 ou mais vezes"] },
    { id: 16, opcoes: ["Não faço monitoramento diário", "Point care para hemoglobina glicada", "Glicemia capilar", "Sistema de monitorização contínua de glicose em líquido intersticial por meio de dispositivos", "Sistema Flash de Monitorização da Glicose"] },
    { id: 17, opcoes: ["menos de 6 meses", "entre 6 meses e 1 ano", "mais de uma ano"] },
    { id: 18, opcoes: [] }
];

function AnamneseMulheresEmagrecimento({ setPerfilAnamnese, setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {

    // Navegação entre etapas
    const [etapa, setEtapa] = useState(1);
    const totalEtapas = 4;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Modal para próxima etapa
    const [isNextModal, setIsNextModal] = useState(false);
    const openNextModal = () => {
        console.log(respostasSelecionadas);
        setIsNextModal(true);
    };
    const closeNextModal = () => {
        setIsNextModal(false);
    };

    // Popup de informações
    const [showInfo, setShowInfo] = useState(false);

    // Modal para selecionar a anamnese
    const [isAnamneseTypeModal, setIsAnamneseTypeModal] = useState(false);
    const openAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(true);
    };
    const closeAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(false);
    };

    const [isChoosingAnamnese, setIsChoosingAnamnese] = useState(false);
    const handleChooseAnamnese = () => {
        setIsChoosingAnamnese(true);
    };

    // SALVAR E BUSCAR NO BD - LEVI
    const [respostasSelecionadas, setRespostasSelecionadas] = useState(
        PERGUNTAS.map(p => ({ id: p.id, valor: p.tipo === 'checkbox' ? [] : "" }))
    );
    const [observacoes, setObservacoes] = useState(evaluationData?.observacoesAnamnese || "");

    useEffect(() => {
        if (evaluationData?.anamnesis) {
            setRespostasSelecionadas(evaluationData.anamnesis);
        }
        if (evaluationData?.observacoesAnamnese !== undefined) {
            setObservacoes(evaluationData.observacoesAnamnese);
        }
    }, [evaluationData]);

    const [selectedAnamnese, setSelectedAnamnese] = useState("anamneseEmagrecimento");
    // FIM

    const handleConfirmTroca = () => {
        // Atualiza o estado no componente pai
        setPerfilAnamnese(selectedAnamnese);
        closeAnamneseTypeModal();
    };

    const atualizarResposta = (perguntaId, novoValor, tipo) => {
        setRespostasSelecionadas(prev => prev.map(item => {
            if (item.id !== perguntaId) return item;

            let valorFinal;
            if (tipo === 'checkbox') {
                const listaAtual = Array.isArray(item.valor) ? item.valor : [];
                valorFinal = listaAtual.includes(novoValor)
                    ? listaAtual.filter(v => v !== novoValor)
                    : [...listaAtual, novoValor];
            } else {
                valorFinal = novoValor;
            }
            return { ...item, valor: valorFinal };
        }));
    };

    const renderPergunta = (id) => {
        const pergunta = PERGUNTAS.find(p => p.id === id);
        if (!pergunta) return null; // Segurança caso o ID não exista

        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const r = rObj ? rObj.valor : (pergunta.tipo === 'checkbox' ? [] : "");
        const opcoesDaPergunta = OPCOES_RESPOSTAS.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="standard-title">{pergunta.texto}</div>
                
                {pergunta.imagem && (
                    <div className="question-image-container" style={{ textAlign: 'center', margin: '10px 0' }}>
                        <img src={pergunta.imagem} alt="Referência" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                    </div>
                )}

                <div className="answer-container">
                    {/* ... Seus inputs (text, checkbox, radio) continuam exatamente iguais ... */}
                    {pergunta.tipo === 'text' && (
                        <input
                            className="answer-text"
                            value={r}
                            placeholder={pergunta.placeholder}
                            onChange={e => atualizarResposta(pergunta.id, e.target.value, 'text')}
                        />
                    )}
                    {/* Mapeamento das opções e lógica de "Outros" seguem abaixo igual ao seu código original */}
                    {opcoesDaPergunta.map(opcao => (
                        <label className="answer-item" key={opcao}>
                            <input
                                type={pergunta.tipo}
                                className={`answer-${pergunta.tipo}`}
                                checked={pergunta.tipo === 'checkbox' ? r?.includes(opcao) : r === opcao}
                                onChange={() => atualizarResposta(pergunta.id, opcao, pergunta.tipo)}
                            />
                            <p className="answer-title">{opcao}</p>
                        </label>
                    ))}
                    {/* ... (manter bloco do temOutros) ... */}
                </div>
            </div>
        );
    };

    // --- LÓGICA DE DIVISÃO EM COLUNAS ---

    // 1. Filtramos as perguntas da etapa atual
    const perguntasDaEtapa = PERGUNTAS.filter((_, idx) => {
        if (etapa === 1) return idx < 8;
        if (etapa === 2) return idx >= 8 && idx < 16;
        return idx >= 16;
    });

    // 2. Calculamos o ponto médio para dividir as colunas
    const meio = Math.ceil(perguntasDaEtapa.length / 2);
    const perguntasEsquerda = perguntasDaEtapa.slice(0, meio);
    const perguntasDireita = perguntasDaEtapa.slice(meio);

    // Navegação provisória
    // A etapa seguinte depende do perfil do aluno (no idoso, Classificação Funcional).
    const proxima = proximaEtapa(aluno?.profile, 'Anamnese');
    const toAntropometria = () => {
        if (proxima) setActiveTab(proxima.chave);
    };

    const handleAnamnesisRegister = async () => {
        const payload = {
            anamnesis: respostasSelecionadas,
            observacoes,
            evaluationId
        };

        const response = await api.post(`/api/student/${aluno.id}/evaluation/anamnesis`, payload, { withCredentials: true });
        if (response.status === 200) {
            // Se o backend retornou um novo ID (pois acabou de criar no banco), nós atualizamos a página pai!
            if (response.data.evaluationId && setEvaluationId) {
                setEvaluationId(response.data.evaluationId);
            }
            if (updateEvaluationData) {
                updateEvaluationData({ anamnesis: respostasSelecionadas, observacoesAnamnese: observacoes });
            }
            openNextModal();
        }
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                {etapa === 1 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[0, 1, 2].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[3, 4].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 2 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[5, 6].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[7, 8].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 3 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[9, 10, 11].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[12, 13, 14].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 4 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[15, 16].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[17, 18].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                <Modal
                    isOpen={isAnamneseTypeModal}
                    onRequestClose={closeAnamneseTypeModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    {isChoosingAnamnese ? (
                        <>
                            <p className="anamnese-modal-type-p">Selecione o tipo de anamnese:</p>
                            <select 
                                className="select-anamnese"
                                value={selectedAnamnese}
                                onChange={(e) => setSelectedAnamnese(e.target.value)}
                            >
                                <option value="anamneseAdultos">Adultos</option>
                                <option value="anamneseEmagrecimento">Mulheres emagrecimento</option>
                                <option value="anamneseIdosos">Idosos</option>
                                <option value="anamneseGestantes">Gestantes</option>
                                <option value="anamnesePosParto">Pós Parto</option>
                                <option value="anamneseObesos">Obesos</option>
                                <option value="anamneseDiabetes">Diabetes</option>
                                <option value="anamneseHipertensao">Hipertensão</option>
                                <option value="anamneseDepressao">Depressao</option>
                            </select>
                            <div>
                                <button className="next-prev-button" onClick={handleConfirmTroca}>
                                    Confirmar Troca
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="anamnese-modal-type-p">
                                De acordo com o perfil do avaliado, recomenda-se<br />
                                anamnese para <span className="anamnese-modal-type-profile">Adultos</span>. Deseja
                                continuar <br /> ou escolher outra anamnese?
                            </p>
                            <div className="sub-pagination-buttons">
                                <button className="next-prev-button" type="button" onClick={closeAnamneseTypeModal}>
                                    Continuar
                                </button>
                                <button className="next-prev-button" type="button" onClick={handleChooseAnamnese}>
                                    Trocar Anamnese
                                </button>
                            </div>
                        </>
                    )}
                </Modal>

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Anamnese finalizada!</p>
                    <p className="popupNext-h2">{textoProximaEtapa(proxima)}</p>
                    <div className="sub-pagination-buttons">
                        <button className="next-prev-button" type="button" onClick={toAntropometria}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                {etapa === totalEtapas && (
                    <div className="anamnese-observacoes">
                        <div className="standard-title">Observações</div>
                        <textarea
                            className="anamnese-observacoes-input"
                            placeholder="Escreva observações adicionais sobre o avaliado..."
                            value={observacoes}
                            onChange={(e) => setObservacoes(e.target.value)}
                        />
                    </div>
                )}

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 4 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={handleAnamnesisRegister}>Registrar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container" >
                        <div className="info-button" onClick={openAnamneseTypeModal}>
                            Trocar Anamnese
                        </div>
                        <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                            <HelpCircle size={20} />
                            Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p className="">A anamnese é a primeira etapa de uma avaliação física e consiste em uma entrevista estruturada entre o profissional
                                    de Educação Física e o avaliado. Seu objetivo é coletar informações detalhadas sobre o histórico de saúde, estilo de vida, hábitos e
                                    objetivos do indivíduo, servindo como base para um planejamento seguro e personalizado do programa de treinamento.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AnamneseMulheresEmagrecimento;